/** Bound browser APIs that provide neither cancellation nor a rejection deadline. */
export async function waitForBrowserOperation<T>(operation: PromiseLike<T>, message: string, milliseconds = 10_000): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([operation, new Promise<never>((_, reject) => {
      timer = setTimeout(() => reject(new Error(message)), milliseconds);
    })]);
  } finally { clearTimeout(timer); }
}
